/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import GameSetup from '../../../Game/GameSetup';
import { ccEnum } from '../../CCEnum';
import InjectableComponent from '../ComponentReference/InjectableComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * A special version of cc.Button that can be triggered by a designated key press.
 */
@cc._decorator.ccclass
export class KeyedButton extends cc.Button
{
    /** The [[ccEnum.ccKEY]] to use for triggering this button. */
    @property({ type: ccEnum.ccKEY, visible: true })
    private _key: cc.KEY = cc.KEY.space;

    /** @hidden */
    private _gameSetupRef: InjectableComponent<GameSetup> = new InjectableComponent<GameSetup>();

    /** @hidden */
    protected start(): void
    {
        if (CC_EDITOR) { return; }

        this._gameSetupRef.SetContext(GameSetup);

        // Register the keybaord events.
        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDown.bind(this), this);
        cc.systemEvent.on(cc.SystemEvent.EventType.KEY_UP, this.onKeyUp.bind(this), this);
    }

    /** @hidden */
    protected onDestroy(): void
    {
        if (CC_EDITOR) { return; }

        // Unregister the keybaord events.
        if (cc.systemEvent)
        {
            cc.systemEvent.off(cc.SystemEvent.EventType.KEY_DOWN, this.onKeyDown.bind(this), this);
            cc.systemEvent.off(cc.SystemEvent.EventType.KEY_UP, this.onKeyUp.bind(this), this);
        }
    }

    /**
     * @hidden
     * @param event Type is any because cc.Event.EventKeyboard
     * does not have keyCode property.
     */
    protected onKeyDown = (event: any): void =>
    {
        if (!this._gameSetupRef.Value.KeyboardEnabled) { return; }
        if (!this.enabledInHierarchy) { return; }

        if (event. keyCode === this._key)
        {
            // Simulate a touch event for the button.
            this.node.emit(cc.Node.EventType.TOUCH_START);
        }
    }

    /** @hidden */
    protected onKeyUp(event: any): void
    {
        if (!this._gameSetupRef.Value.KeyboardEnabled) { return; }
        if (!this.enabledInHierarchy) { return; }

        if (event.keyCode === this._key)
        {
            // Simulate a touch event for the button.
            this.node.emit(cc.Node.EventType.TOUCH_END);
        }
    }
}
